import {
    CreateTranscriptionRequest,
    Transcription,
    TranscriptionsService,
  } from '@/api/';
import { Bytes } from 'firebase/firestore';
  import { action, atom, onSet } from 'nanostores';
  
  /**
   * The current selected workspace
   */
  export const $transcription = atom<Transcription | undefined>();
  
  /**
   * The workspaces for the current selected user and org.
   */
  export const $transcriptions = atom<Transcription[]>([]);
  
  /**
   * Main function to load knowledgebases
   */
  const loadTranscriptions = async (orgId: string) => {
    if (orgId) {
      console.log('Retrieving transcriptions...');
  
      await ensureOrganization(orgId);
  
      var transcriptions = await TranscriptionsService.getTranscriptions(orgId);

      $transcriptions.set(transcriptions);
  
      // set the workspace ids in local storage since we are gonna use it later
      // for drag and drop, these workspace ids will act as order of the workspaces
      const existingTranscriptionOrder = JSON.parse(
        localStorage.getItem('transcription_orders') ?? '{}',
      );
      existingTranscriptionOrder[orgId] = transcriptions.map(w => w.id);
      localStorage.setItem(
        'transcription_orders',
        JSON.stringify(existingTranscriptionOrder),
      );
    }
  };
  
  /**
   * Reload workspaces on org change
   */
  $org.subscribe(async org => {
    $knowledgebases.set([]);
  
    await loadTranscriptions(org?.id ?? '');
  });
  
  /**
   * When the transcription changes, we subscribe for notifications.
   */
  onSet($transcription, async kb => {
    if (!kb.newValue) {
      return;
    }
  
    if (kb.newValue.id == $transcription.get()?.id) {
      return;
    }
  
    await signalRService.joinWorkspaceGroup(kb.newValue.id);
  });
  
  /**
   * Watch for route changes; if we haven't loaded the orgs, we try to load them.
   */
  route.subscribe(async name => {
    if (name !== 'transcriptions' || ($transcriptions.value?.length ?? 0) > 0) {
      return;
    }
  
    const params = $router.get()?.params as Record<'organizationId', string>;
  
    await loadTranscriptions(params.organizationId);
  });
  
  /**
   * Create a new workspace
   * TODO: Include profile selection/invites.
   */
  export const createTranscription = action(
    $transcription,
    'createTranscription',
    async (store, audioFileName: string, fileContent: File, extension: string) => {
      const params = $router.get()?.params as Record<'organizationId', string>;
  
      const request: CreateTranscriptionRequest = {
        audioFileName,
        organizationId: params.organizationId,
        fileContentsBase64: await file2Base64(fileContent),
        extension,
      };
  
      const response = await TranscriptionsService.createTranscription(request);

      if (!response.transcription) {
        // error is displayed by caller
        return response;
      }

      $transcription.set(response.transcription);
      $transcriptions.set([response.transcription, ...$transcriptions.get()]);
     
    },
  );
  
  /**
   * Delete's the selected workspace.
   */
//   export const deleteTranscription = action(
//     $transcription,
//     'deleteTranscription',
//     async (store, transcriptionId: string) => {
//       await TranscriptionsService.deleteTranscription(transcriptionId);
  
//       $transcription.set(undefined);
  
//       // Splice out the project
//       const transcriptions = $transcriptions.get();
  
//       const index = transcriptions.findIndex(w => w.id === transcriptionId);
  
//       if (index > -1) {
//         transcriptions.splice(index, 1);
  
//         $transcriptions.set(transcriptions);
//       }
//     },
//   );

  /**
   * Ensure that the transcription is loaded and selected.
   */
  export const ensureTranscription = action(
    $transcription,
    'ensureTranscription',
    async (store, transcriptionId: string) => {
      let ts: Transcription | undefined;
  
      const params = $router.get()?.params as Record<'organizationId', string>;
  
      if ($transcriptions.get().length === 0) {
        const transcriptions = await TranscriptionsService.getTranscriptions(
          params.organizationId ?? '',
        );
  
        $transcriptions.set(transcriptions);
  
        ts = transcriptions.find(w => w.id === transcriptionId);
      } else {
        ts = $transcriptions.get().find(w => w.id === transcriptionId);
      }
  
      $transcription.set(ts);
    },
  );
  